<template>
  <div class="approval-card" :class="`state-${state}`">
    <div class="approval-head">
      <span class="approval-label">需要确认</span>
      <span class="approval-tool">{{ label || name || '操作' }}</span>
    </div>
    <p v-if="summary" class="approval-summary">{{ summary }}</p>
    <pre v-if="argsPreview" class="approval-args">{{ argsPreview }}</pre>
    <div v-if="state === 'pending'" class="approval-actions">
      <el-button size="small" type="primary" :loading="busy" @click="decide(true)">批准</el-button>
      <el-button size="small" :disabled="busy" @click="decide(false)">拒绝</el-button>
    </div>
    <div v-else class="approval-result">
      {{ state === 'approved' ? '已批准' : state === 'rejected' ? '已拒绝' : state }}
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { agentApi } from '../../api'

export default {
  name: 'AgentApprovalCard',
  props: {
    approvalId: { type: String, required: true },
    name: { type: String, default: '' },
    label: { type: String, default: '' },
    summary: { type: String, default: '' },
    args: { type: Object, default: () => ({}) },
    state: { type: String, default: 'pending' },
  },
  emits: ['resolved'],
  setup(props, { emit }) {
    const busy = ref(false)
    const argsPreview = computed(() => {
      try {
        const s = JSON.stringify(props.args || {}, null, 0)
        return s.length > 180 ? s.slice(0, 180) + '…' : s
      } catch {
        return ''
      }
    })

    const decide = async (approved) => {
      if (!props.approvalId || busy.value) return
      busy.value = true
      try {
        await agentApi.approve({
          approval_id: props.approvalId,
          approved: !!approved,
        })
        emit('resolved', { approvalId: props.approvalId, approved: !!approved })
      } catch (e) {
        ElMessage.error('审批失败: ' + (e.message || e))
      } finally {
        busy.value = false
      }
    }

    return { busy, argsPreview, decide }
  },
}
</script>

<style scoped>
.approval-card {
  margin: 8px 0;
  padding: 10px 12px;
  border: 1px solid #e6a23c;
  border-radius: 8px;
  background: #fdf6ec;
}
.approval-card.state-approved {
  border-color: #67c23a;
  background: #f0f9eb;
}
.approval-card.state-rejected {
  border-color: #f56c6c;
  background: #fef0f0;
}
.approval-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.approval-label {
  color: #e6a23c;
  font-weight: 600;
}
.approval-tool {
  color: #303133;
}
.approval-summary {
  margin: 6px 0 0;
  font-size: 12px;
  color: #606266;
}
.approval-args {
  margin: 6px 0 0;
  font-size: 11px;
  color: #909399;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 72px;
  overflow: auto;
}
.approval-actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}
.approval-result {
  margin-top: 8px;
  font-size: 12px;
  color: #606266;
}
</style>
